import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EmailBookingFlowComponent } from '../email-booking-flow/email-booking-flow.component';


const routes: Routes = [
  {
    path: '',
    component: EmailBookingFlowComponent,
    data: { title: 'Traveller Details' }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class EmailBookingFlowRoutingModule {

}